import { HttpErrorResponse } from '@angular/common/http';
import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  OnInit,
  ViewChild,
} from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute } from '@angular/router';
import { Router, NavigationEnd } from '@angular/router';
import { debounceTime, filter } from 'rxjs/operators';
import { RfqCacheService } from 'src/app/views/dashboard/rfq-cache.service';
import {
  AbstractControl,
  FormBuilder,
  FormArray,
  FormControl,
  FormGroup,
  NgForm,
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { SearchService } from 'src/app/views/search/search/search.service';
import { SettingsService } from 'src/app/views/settings/settings.service';
import { Observable, Subject, Subscription } from 'rxjs';
import { Page } from 'src/app/shared/models/page';
import {
  aboutDataType,
  AutoCompleteDataType,
  AutoCompleteSupplierProduct,
  Currency,
  quoteAttachmentType,
  quoteDeclineReasonType,
  incoterms,
  offeredQuality,
  portData,
  supplierBranchData,
  Vessel,
} from 'src/app/shared/models/settings.model';
import { FullLoaderService } from 'src/app/shared/services/full-loader.service';
import { CookieService } from 'ngx-cookie-service';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
// import { SupplierService } from '../../supplier/supplier-dashboard/supplier-dashboard.service';
import { SupplierService } from '../../dashboard/supplier/supplier-dashboard/supplier-dashboard.service';
import { SupplierService as ss } from 'src/app/views/settings/suppliers/supplier.service';
import { Supplier } from 'src/app/shared/models/supplier.model';
import { MatDialog as MatDialog } from '@angular/material/dialog';
import { LocalStoreService } from 'src/app/shared/services/local-store.service';
import { QuoteService } from '../../dashboard/quote/quote.service';
import { RfqGenerateFormService } from '../../dashboard/rfq/rfq-generate-form/rfq-genearte-form.service';
import { NgxFileDropEntry } from 'ngx-file-drop';
import { MatSelectChange } from '@angular/material/select';
import { v4 as uuidv4 } from 'uuid';
import { WebApiService } from 'src/app/shared/services/web-api.service';
import { AwsSdkService } from 'src/app/shared/services/aws-sdk.service';
import { DatatableComponent } from '@swimlane/ngx-datatable';
import { BuyerService } from 'src/app/views/settings/buyers/buyer.service';
import { AttachmentTypes } from 'src/app/shared/common/Enums';
import { MatRadioChange } from '@angular/material/radio';
import { DataTransferService } from 'src/app/shared/services/data-transfer.service';
import { PurchaseOrderService } from 'src/app/views/operations/purchase-order/purchase-order.service';
import moment from 'moment';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import { InvoiceService } from '../create-invoice/invoice-service';
import { MatCheckboxChange } from '@angular/material/checkbox';
// import * as html2pdf from 'html2pdf.js';


interface Attachment {
  name: string;
  systemName: string;
  fileKey: string;
  s3_path: string;
}


interface Location {
  locationId: number;
  locationName: string;
  code: string;
}

interface Incoterm {
  incotermId: number;
  incotermCode: string;
  userId: number;
  locationDetails: Location[];
}

@Component({
  selector: 'app-order-receipt-details',
  templateUrl: './order-receipt-details.component.html',
  styleUrls: ['./order-receipt-details.component.css']
})
export class OrderReceiptDetailsComponent  implements OnInit {
  @ViewChild('table') table!: DatatableComponent;
  @ViewChild('pdfContent') contentToPrint!: ElementRef<HTMLDivElement>;
  rfqId!: number;
  quoteId!: number;
  purchaseOrderId!: number;
  receiptId!: any;
  dispatchId!:number;
  userId!: number;
  isSaved: boolean = false;
  currentTab: string = 'preview';
  tabEnabled: boolean = false;

  showConfirmationDialogue: boolean = false;
  showSuccessDialogue: boolean = false;
  showCloseDialogue: boolean = false;
  previewSection: boolean = false;
  previewDocs: any[] = [];
  currentIndex = 0;

  showAddDispatchRequirement:boolean=false
  selectedType:string=''
  showNewType:boolean=true
  typeName:string=''

  showAcceptOrder: boolean = false;
  showRejectOrder: boolean = false;
  showOrderConfirmed: boolean = false;


  freightValues: any[] = [];
  availableModes: any[] = [];



  showNotification: boolean = false;
  showSuccessMessage: boolean = false;
  showFeedbackSection: boolean = false;

  notificationMessage: string = '';
  notificationTitle: string = '';
  notificationType: 'error' | 'info' = 'error';



  selectedAttachmentType!: number | null;
  hazardousDeclaration!: number | null;
  newfileuploaded: boolean = false;
  uploadedAttachmentsArray: any[] = [];
  dispatchAttachments: any[] = [];
  acceptedAttachmentExtenstion: any = ['.pdf', '.jpg', '.jpeg', '.png'];
  maxFileSize: number = 10 * 1024 * 1024; //10MB

  currentdate = new Date();



  isForm1Expand: boolean = false;
  isForm2Expand: boolean = true;
  isForm3Expand: boolean = true;




  lastId!: number;
  headerAttachmentUrl: any;
  headerAttachmentSection: boolean = false;
  paymentTermsAndConditionsSection: boolean = false;
  buyerAttachmentsSection: boolean = false;
  paymentTermsAndConditions: any;
  paymentTermsAndConditionAttachmentUrl: any;
  buyerAttachmentUrl: string[] = [];
  incoterms: incoterms[] = [];
  offeredQualityData: offeredQuality[] = [];
  headerAttachmentType: quoteAttachmentType[] = [];
  lineItemAttachmentType: quoteAttachmentType[] = [];






  // countries: Countries[] = [];
  countries: any[] = [];
  filteredCountries: any[] = [];
  selectedCountries: any[] = [];
  incotermLocationList: any[] = [];


  dispatchFormGroup!: UntypedFormGroup;
  requirementsFormGroup!: UntypedFormGroup;
  orderReceiptForm!: UntypedFormGroup;
  feedbackForm!: UntypedFormGroup;

  feedbackData:any;
  incotermLocations: string = '';

  incotermsCode: number | null = null;


  uploadedAdditionalAttachmentsArray: any[] = [];


  dispatchRequirementList: any[] = []
  requirementTypes: any[] = []
  typeData: any[] = []
  minDate: Date = new Date();
  selectedRequirements:any[]=[]



  stars = [1, 2, 3, 4, 5];
  rating = 0;
  recommend: boolean | null = null;
  comments = '';
  isFeedbackSubmitted : boolean = false
  isBuyer: boolean = false

  constructor(
    private snack: MatSnackBar,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private rfqCacheService: RfqCacheService,
    private _formBuilder: UntypedFormBuilder,
    private cdr: ChangeDetectorRef,
    private searchService: SearchService,
    private SettingsService: SettingsService,
    private fullLoaderService: FullLoaderService,
    private supplierService: SupplierService,
    private ss: ss,
    public dialog: MatDialog,
    private ls: LocalStoreService,
    private quoteService: QuoteService,
    private RfqGenerateFormService: RfqGenerateFormService,
    private cookieService: CookieService,
    private webApiService: WebApiService,
    private awsSdkService: AwsSdkService,
    private CookieService: CookieService,
    private dataTransferService: DataTransferService<any>,
    private purchaseOrderService: PurchaseOrderService,
    private route: ActivatedRoute,
    private invoiceService: InvoiceService

  ) {

  }

  async ngOnInit() {

    let userRole = this.cookieService.get("userRole") ? this.cookieService.get("userRole") : null;
    this.isBuyer = userRole == 'Owner'

    this.dispatchFormGroup = this._formBuilder.group({
      dispatchId: [null],
      rfqId: [null],
      quoteId: [null],
      receiptId: [null],
      poId: [null],
      invoiceId: [null],
      rfqRefNumber: [''],
      quoteRefNumber: [''],
      poRefNumber: [''],
      invoiceRefNumber: [''],
      supplierDispatchRefNumber: [''],
      incoterms: [''],
      dispatchDate: [''],
      freightForwarderId: [''],
      freightForwarder: [''],
      modeOfTransport: [''],
      awbNumber: [''],
      trackingLink: [''],
      dispatchAttachments:[],
      supplierId:  [''],
      supplierName:  [''],


    });


    this.orderReceiptForm = this._formBuilder.group({
      receiptId: [null],
      dispatchId: [null],
      quotationId:[null],
      rfqId:[null],
      purchaseOrderId:[null],
      invoiceId:[null],
      receivedDate: [new Date()],
      receivedBy: [null],
      remarks: [null],
      receiptAttachments:[],
      isConfirmed:[false],
      buyerId: Number(this.cookieService.get('userId')),
      buyerName: [null],
      submittedOn: [null],
      vesselName: [null],
      vesselImoNumber: [null],
    });

    this.feedbackForm = this._formBuilder.group({
      feedbackId: [null],
      rfqId: [null],
      quotationId: [null],
      purchaseOrderId: [null],
      invoiceId: [null],
      dispatchId: [null],
      receiptId: [null],
      supplierId: [null],
      buyerId: [null],
      ratings: [0, [Validators.required, Validators.min(1)]],
      wouldYouRecommend: [null],
      comments: [null],
      submittedOn: [null],
    });



    this.dispatchFormGroup.disable()
    this.orderReceiptForm.disable()
    this.dispatchFormGroup.get('trackingLink')?.enable({ emitEvent: false })
    




    this.activatedRoute.queryParams.subscribe(async params => {


      if (params['receiptId'] != '' && params['dispatchId'] != '' ) {

        this.receiptId = params['receiptId']
        this.dispatchId = params['dispatchId']

        if (this.receiptId != 'new') {

          this.fetchDispatchData()
          this.fetchConfirmReceiptData()
         
        }
        

      }


    })


    this.route.queryParams.subscribe((params) => {
      const poId = params['poId'];
      const rfqId = params['rfqId'];
      const quoteId = params['quoteId'];
      const poStatusValue = params['poStatusValue'];

      console.log('CreateInvoiceComponent -> query params:', params);
      console.log('CreateInvoiceComponent -> IDs:', {
        poId,
        rfqId,
        quoteId,
        poStatusValue,
      });
    });

  }

  toggleVisibility(section: string) {

    if (section == 'form1') {
      this.isForm1Expand = !this.isForm1Expand;
    } else if (section == 'form2') {
      this.isForm2Expand = !this.isForm2Expand;
    } else if (section == 'form3') {
      this.isForm3Expand = !this.isForm3Expand;
    }
  }

  async save(isDraft?: boolean) {
    console.log('INSIDE SAVE');
    this.fullLoaderService.showLoader();

    if (isDraft) {
      this.showConfirmationDialogue = false;
      this.showCloseDialogue = false;
    }

    // const params = {
    //   section: 'preview',
    //   purchaseOrderStatus: isDraft ? 14 : 3,
    //   purchaseOrderTabId: 4,
    //   quoteId: this.quoteId,
    //   userId: Number(this.cookieService.get('userId')),
    //   purchaseOrderId: this.purchaseOrderId,
    //   termsConditionsAttachment:
    //     this.paymentFormGroup.get('attachments')?.value,
    //   rfqId: this.rfqId,
    // };

    // const result = await this.purchaseOrderService.updatePurchaseOrder(params);
    // this.fullLoaderService.hideLoader();
    // if (!isDraft) {
    //   setTimeout(() => {
    //     this.router.navigate(['dashboard', 'supplier']);
    //   }, 3000); // 3000 milliseconds = 3 seconds
    // }
  }



  async back() {

  }

  async next() {

  }








  allowOnlyLetters(event: KeyboardEvent) {
    const charCode = event.key.charCodeAt(0);
    // Allow A-Z, a-z and space
    if (
      !(charCode >= 65 && charCode <= 90) && // uppercase letters
      !(charCode >= 97 && charCode <= 122) && // lowercase letters
      !(charCode === 32) // space
    ) {
      event.preventDefault();
    }
  }


















  async close(isDraft: boolean) {
    if (!isDraft) {
      this.showConfirmationDialogue = true;
    } else {
      this.router.navigate(['operations', 'supplier-purchase-order-list']);
    }
  }

  cancel() {
    this.showConfirmationDialogue = false;
    this.showCloseDialogue = false;
    this.showAcceptOrder = false;
    this.showRejectOrder = false;
    this.showOrderConfirmed = false;
  }


  // Function to display the notification with missing fields
  showMissingFieldsNotification(
    missingFields: { section: string; fields: string[] }[]
  ) {
    let message =
      '<strong>Please fill all the missing fields before proceeding:</strong><br><br>';

    // Loop through each section and list its missing fields
    missingFields.forEach((missingField) => {
      message += `<strong>${missingField.section}:</strong><br>`; // Add section name
      message += missingField.fields
        .map((field) => `  • ${field}`)
        .join('<br>'); // List missing fields with bullet points
      message += '<br><br>'; // Add extra spacing between sections
    });

    this.notificationMessage = message;
    this.notificationTitle = 'Missing Fields';
    this.notificationType = 'error'; // Change this to 'info' for informational notifications
    this.showNotification = true; // Display the notification
  }



  isValidRequiredFields(): { section: string; fields: string[] }[] {
    const missingFields: { section: string; fields: string[] }[] = [];



    return missingFields;
  }


  nextSlide() {
    this.currentIndex = (this.currentIndex + 1) % this.previewDocs.length;
  }

  prevSlide() {
    this.currentIndex =
      (this.currentIndex - 1 + this.previewDocs.length) % this.previewDocs.length;
  }

  async togglePreview(value: boolean, section: string) {
    
    this.currentIndex = 0;

    if (value) {
      if (section == 'additionalDocument') {
          this.previewDocs = this.dispatchAttachments.filter(item => item.attachmentType === 'additionalDocument');
        } 
      else if(section == 'proofOfPickup') {
        this.previewDocs = this.dispatchAttachments.filter(item => item.attachmentType === 'proofOfPickup');
      }
      else if(section == 'receiptAdditionalAttachment'){  
        this.previewDocs = this.uploadedAttachmentsArray.filter(item => item.attachmentType === 'additionalDocument');
      }
      else if(section == 'deliveryNoteDocument'){
        this.previewDocs = this.uploadedAttachmentsArray.filter(item => item.attachmentType === 'deliveryNoteDocument');
      }
    } else {
      this.previewDocs = [];
    }
    console.log('previewDoc', this.previewDocs,  this.previewDocs[this.currentIndex]);
    this.previewSection = value;
  }



  async onAddtionalFileSelected(files: NgxFileDropEntry[]) {
    try {
      this.fullLoaderService.showLoader();
      this.uploadedAdditionalAttachmentsArray = [];

      if (this.uploadedAdditionalAttachmentsArray.length > 5) {
        throw new Error('Maximum 5 files allowed for a product!');
      }

      const fileEntries = files
        .filter((entry) => entry.fileEntry.isFile)
        .map((ele) => ele.fileEntry as FileSystemFileEntry);

      console.log(fileEntries, 'fileEntries');

      if (fileEntries.length === 0) {
        throw new Error('Please upload valid files!');
      }
      if (fileEntries.length > 5) {
        throw new Error('Maximum 5 files allowed for a product!');
      }

      await new Promise((res, rej) => {
        fileEntries.map((fileEntry) => {
          fileEntry.file(async (file) => {
            let fileExt = file.name.split('.').pop();
            if (!this.acceptedAttachmentExtenstion.includes(`.${fileExt}`)) {
              // rej('Invalid filetype!');
              return;
            }

            if (file.size > this.maxFileSize) {
              throw new Error('File size must be less than 5MB!');
            }

            let uploadedAttachment: any = {
              dataUrl: '',
              name: file.name,
              file: file,
            };

            await new Promise((res, rej) => {
              const reader = new FileReader();
              reader.onload = (e: any) => {
                uploadedAttachment.dataUrl = e.target.result; // Store the data URL for preview
                res(true);
              };
              reader.readAsDataURL(file); // Read the file as a data URL
            });

            this.uploadedAdditionalAttachmentsArray.push(uploadedAttachment);
            res(file);
          });
        });
      });

      // this.paymentFormGroup
      //   .get('attachments')
      //   ?.setValue(this.uploadedAdditionalAttachmentsArray);
      this.fullLoaderService.hideLoader();
    } catch (error: any) {
      this.snack.open(error, 'OK', {
        duration: 1000,
      });
    }
  }

  openFileSelector() { }

  async submit() {
    // // if (!isDraft) {
    // //   this.showConfirmationDialogue = true;
    // // } else {
    // //   this.showCloseDialogue = true;
    // // }

    this.fullLoaderService.showLoader();

    const dateString1 = this.orderReceiptForm.value.receivedDate ? moment(this.orderReceiptForm.value.receivedDate).format("YYYY-MM-DDTHH:mm:ss") + "Z" : null;

    this.orderReceiptForm.patchValue({
      receivedDate: dateString1,
      buyerId: Number(this.cookieService.get('userId'))
    });

    let formData = this.orderReceiptForm.value
     


    let attachmentFiles:any = {} 
    let formObj = this.orderReceiptForm.value
    let attachmentArray = [...this.uploadedAttachmentsArray]

    attachmentArray = attachmentArray.filter(item=>item.file)
          
    // generate the s3 upload content for each attachment file
    let uploadPath = `comfirm-order-receipt/${this.orderReceiptForm.get('receiptId')?.value}`
      
      await Promise.all(attachmentArray.map(async(attachment:any,index:any)=>{
        if(!attachment.file){
              return
        }

            let fileName = attachment.file.name
            let fileExt = attachment.name.slice(
              ((attachment.name.lastIndexOf('.') - 1) >>> 0) + 2
            );
            
            let fileNameSystem = `${uuidv4()}.${fileExt}`

            attachment.systemName = fileNameSystem //This name denotes the fileNames for our system records
            let s3Location = `${uploadPath}/${fileName}`; //!this location to be verified before starting upload
      
            let _s3Params = {
              fileKey: s3Location,
              fileContentType: (<File>attachment.file).type,
            };
            attachment.s3Params = _s3Params
            attachmentFiles[attachment.file.name] = attachment.file
      }))

          console.log({attachmentArray});
          // get presigned urls for all the attachments in bulk
          formObj.receiptAttachments = await this.SettingsService.getBulkAttachmentUrls(attachmentArray)

          formObj.receiptAttachments.map(async(attachment:any)=>{
            attachment.s3_path = this.awsSdkService.extractS3LocationFromUrl(attachment.s3_path)
            attachment.fileKey = attachment.s3Params.fileKey
          })

          // upload all the iamges to s3 bucket
          await Promise.all(formObj.receiptAttachments.map(async (attachment:any)=>{
            this.webApiService.putRequestExternalApi(attachment.s3_path, attachmentFiles[attachment.name])
          }))
		  
		  
		  
		  
		  if (this.receiptId == 'new' && this.orderReceiptForm.get('receiptId')?.value == null) {
  
       

        const result = await this.invoiceService.confirmOrderReceipt(formData);
  
  
        if (result?.data) {
  
          this.fullLoaderService.hideLoader()
  
          this.snack.open(`Confirmation of order receipt submitted successfully`, "OK", { duration: 3000 });
  
          this.isSaved = true;
  
          this.receiptId = result.data

          this.showSuccessMessage = true


          this.feedbackForm.patchValue({
            receiptId: this.receiptId,
            buyerId:  Number(this.cookieService.get('userId')),
           
          });

          // this.router.navigate(['/operations/invoice-list']);
  
         
  
  
        } else {
          this.fullLoaderService.hideLoader()
          throw new Error('Invalid response format: Expected { data: number }');
        }
  
      }
      else if (this.receiptId != 'new' &&
        this.orderReceiptForm.get('receiptId')?.value 
  
      ) {
  
        
  
      }


   
    this.fullLoaderService.hideLoader();
    // if (!isDraft) {
    //   setTimeout(() => {
    //     this.router.navigate(['dashboard', 'supplier']);
    //   }, 3000); // 3000 milliseconds = 3 seconds
    // }
    
  }

  toggleBlur(): void {
    const element = document.querySelector('.blurry');
    if (element) {
      element.classList.toggle('blur');
    } else {
      console.warn('Element with class "blurry" not found.');
    }
  }

  isPdf(urlOrDataUrl: string): boolean {
    if (urlOrDataUrl?.toLowerCase().startsWith('data:application/pdf')) {
      return true; // For data URLs, check if the MIME type is 'application/pdf'
    }
    return urlOrDataUrl?.toLowerCase().endsWith('.pdf'); // For URLs, check if it ends with '.pdf'
  }


  async closeCreateDispatchPage() {
    this.router.navigate(['/operations/invoice-list']);
  }

  dismissNotification() {
    this.showNotification = false;
  }



  toggleSidebar(value:boolean, section:string){
    if(section == 'requirementForm'){
      this.showAddDispatchRequirement = value
    }
   
  }




  getProofOfPickupAttachment(){

    const proofOfPickupAttachments = this.dispatchAttachments.filter(
      item => item.attachmentType === 'proofOfPickup'
    );

    return proofOfPickupAttachments;
  }

  getAdditionalAttachment(){

    const additionalAttachments = this.dispatchAttachments.filter(
      item => item.attachmentType === 'additionalDocument'
    );

    return additionalAttachments;

  }


  getDeliveryDocumentsAttachment(){
    
   
    const deliveryNoteDocument = this.uploadedAttachmentsArray.filter(
      item => item.attachmentType === 'deliveryNoteDocument'
    );

    return deliveryNoteDocument;
  }
  
  getReceiptAdditionalAttachment(){
    
    const additionalAttachments = this.uploadedAttachmentsArray.filter(
      item => item.attachmentType === 'additionalDocument'
    );

    return additionalAttachments;

  }

  async fetchDispatchData(){

    this.fullLoaderService.showLoader()

    const data = await this.invoiceService.fetchDispatchDetailsByDispatchId(Number(this.dispatchId))
    console.log(data,'data', data.length,data[0].dispatchId)

    if (data && data.length > 0){
    
                
      this.dispatchFormGroup.patchValue({

      
      dispatchId: data[0].dispatchId,
      rfqId: data[0].rfqId,
      quoteId: data[0].quotationId,
      receiptId: data[0].receiptId,
      poId: data[0].purchaseOrderId,
      rfqRefNumber: data[0].rfqRefNumber,
      quoteRefNumber: data[0].quoteRefNumber,
      poRefNumber: data[0].purchaseOrderRefNumber,
      invoiceRefNumber: data[0].invoiceNumber,
      supplierDispatchRefNumber: data[0].supplierDispatchRefNo,
      incoterms: data[0].incotermCode,
      dispatchDate: data[0].dispatchDate,
      freightForwarderId: data[0].freightId,
      freightForwarder: data[0].freightForwarder,
      modeOfTransport: data[0].modeOfTransportName,
      awbNumber: data[0].awbNumber,
      trackingLink: data[0].trackingLink,
      dispatchAttachments:data[0].dispatchAttachments || [],
      supplierId: Number(data[0].supplierId),
      supplierName:data[0].supplierCompanyName

    });


    this.dispatchAttachments = data[0].dispatchAttachments || []
    this.selectedRequirements = data[0].requirementDetails

    }

    this.fullLoaderService.hideLoader()

  }

  getTrackingLinkUrl(): string | null {
    const trackingLink = this.dispatchFormGroup?.get('trackingLink')?.value;
    if (!trackingLink) {
      return null;
    }

    return trackingLink.match(/^https?:\/\//i)
      ? trackingLink
      : `https://${trackingLink}`;
  }

  openTrackingLink(): void {
    const url = this.getTrackingLinkUrl();
    if (url) {
      const newWindow = window.open(url, '_blank');
      if (newWindow) {
        newWindow.opener = null;
      }
    }
  }

  async fetchConfirmReceiptData(){

    this.fullLoaderService.showLoader()

    let params = {
      dispatchId:this.dispatchId,
      receiptId:this.receiptId
    }

    const data = await this.invoiceService.fetchConfirmReceiptDetailsByReceiptId(params)
    console.log(data,'data', data.length,data[0])
    if (data && data.length > 0){

      this.orderReceiptForm.patchValue({
        receiptId: data[0].receiptId,
        dispatchId:  data[0].dispatchId,
        quotationId: data[0].quotationId,
        rfqId: data[0].rfqId,
        purchaseOrderId: data[0].purchaseOrderId,
        invoiceId: data[0].invoiceId,
        receivedDate : data[0].receivedDate 
        ? new Date(data[0].receivedDate) 
        : null,
        // receivedBy:  data[0].buyerCompanyName,
        receivedBy: data[0].receivedBy,
        remarks:  data[0].buyerRemarks,
        receiptAttachments: data[0].receiptAttachments,
        isConfirmed: data[0].isConfirmed,
        buyerId:  data[0].buyerId,
        buyerName: data[0].buyerCompanyName,
        submittedOn: data[0].receiptSubmittedOn,
        vesselName: data[0].vesselName,
        vesselImoNumber: data[0].vesselImoNumber,
        
      });

      this.uploadedAttachmentsArray = data[0].receiptAttachments

      this.isFeedbackSubmitted = data[0].isFeedbackSubmitted



      this.feedbackForm = this._formBuilder.group({
        feedbackId: data[0].feedbackId,
        rfqId: data[0].rfqId,
        quotationId: data[0].quotationId,
        purchaseOrderId: data[0].purchaseOrderId,
        invoiceId: data[0].invoiceId,
        dispatchId: data[0].dispatchId,
        receiptId: data[0].receiptId,
        supplierId: data[0].supplierId,
        buyerId: data[0].buyerId,
        ratings: data[0].ratings || 0,
        wouldYouRecommend: data[0].wouldYouRecommend || false,
        comments: data[0].feedbackComments,
        submittedOn: data[0].feedbackSubmittedOn,
      });

      this.feedbackData = {
        feedbackId: data[0].feedbackId,
        rfqId: data[0].rfqId,
        quotationId: data[0].quotationId,
        purchaseOrderId: data[0].purchaseOrderId,
        invoiceId: data[0].invoiceId,
        dispatchId: data[0].dispatchId,
        receiptId: data[0].receiptId,
        supplierId: data[0].supplierId,
        buyerId: data[0].buyerId,
        ratings: data[0].ratings || 0,
        wouldYouRecommend: data[0].wouldYouRecommend || false,
        comments: data[0].feedbackComments,
        submittedOn: data[0].feedbackSubmittedOn,
        supplierCompanyName: data[0].supplierCompanyName,
        buyerCompanyName:data[0].buyerCompanyName,
        receivedBy: data[0].receivedBy
      }

    }
   
    this.fullLoaderService.hideLoader()

  }

  openFeedback(){
   this.showFeedbackSection = true
   this.closeSuccessPopUp()
  }

  closeSuccessPopUp(){
    this.showSuccessMessage = false
  }




  setRating(value: number) {
    this.feedbackForm.patchValue({ ratings: value });
  }

  setRecommendation(value: boolean) {
    this.feedbackForm.patchValue({ wouldYouRecommend: value });
  }
  
  async submitFeedback() {

    this.fullLoaderService.showLoader()

    if(this.feedbackForm.valid && typeof this.feedbackForm.value.receiptId === 'number'){

      if (!this.feedbackForm.value.feedbackId && !this.isFeedbackSubmitted) {

        console.log('inside add')
        // const result = await this.invoiceService.createSupplierFeedback(this.feedbackForm.value);
  
  
        // if (result?.data) {
  
        //   this.fullLoaderService.hideLoader()
  
        //   this.snack.open(`Supplier feedback submitted successfully`, "OK", { duration: 3000 });

        //   this.router.navigate(['/operations/invoice-list']);
  
  
        // } else {
        //   this.fullLoaderService.hideLoader()
        //   throw new Error('Invalid response format: Expected { data: number }');
        // }
  
      }
      else {
  
        console.log('inside update')
        const result = await this.invoiceService.udateSupplierFeedback(this.feedbackForm.value.feedbackId, this.feedbackForm.value);
        this.fullLoaderService.hideLoader()
  
        this.snack.open(`Supplier feedback submitted successfully`, "OK", { duration: 3000 });

      }

    }
   
    this.dismissFeedback();
  }
  
  dismissFeedback() {
    this.showFeedbackSection = false
  }

  async downloadDocFile(dataURI:any) {
  
    this.fullLoaderService.showLoader()
  
    const extension = dataURI?.split('.').pop()?.split('?')[0] || 'file';
  
    const name = Math.random().toString(36).substring(2, 10);
  
    const fileName = `DOC-${name}.${extension}`;
  
    await this.dataTransferService.downloadFile(dataURI, fileName);
  
    this.fullLoaderService.hideLoader()
  
  }



}
